import * as types from "../mutation-types";
import services from "services/offers";
import _ from "lodash";

const state = {
  sessions: [],
  selectedSession: {},
  filtered: false,
  filters: {
    category: null,
    offer: null,
    destinations: [],
    themes: [],
    date: null,
    durations: null
  },
  pagination: [],
  offerSessions: {
    sessions: [],
    pagination: [],
    filtered: false,
    filters: {
      category: null,
      offer: null,
      destinations: [],
      themes: [],
      date: null,
      durations: null
    }
  }
};

const getters = {
  filters: state => state.filters,
  isFilteredSessions: state => state.filtered,
  sessions: state => state.sessions,
  selectedSession: state => state.selectedSession,
  pagination: state => state.pagination,
  offerFilters: state => state.offerSessions.filters,
  isFilteredOfferSessions: state => state.offerSessions.filtered,
  offerSessions: state => state.offerSessions.sessions,
  offerPagination: state => state.offerSessions.pagination
};

const actions = {
  async fetchSessions({ commit }, query) {
    const payload = (await services.filterSessions(query)).data;
    commit("fetchSessions", payload);
    commit("setOfferFilters");
  },
  async fetchOfferSessions({ commit }, query) {
    const payload = (await services.filterSessions(query)).data;
    commit("fetchOfferSessions", payload);
  },
  deleteFilter: ({ commit }, category, selected) => {
    commit("deleteFilter", category, selected);
  },
  deleteOfferFilter: ({ commit }, category, selected) => {
    commit("deleteOfferFilter", category, selected);
  },
  filteredSessions: ({ commit }, filter) => {
    commit("filteredSessions", filter);
  },
  filteredOfferSessions: ({ commit }, filter) => {
    commit("filteredOfferSessions", filter);
  },
  selectSession: ({ commit }, session) => {
    commit("selectSession", session);
  }
};

const mutations = {
  fetchSessions: (state, payload) => {
    state.sessions = payload.sessions;
    state.filtered = true;
    state.pagination = payload.meta.pagination;
  },
  setOfferFilters: state => {
    state.offerSessions.filters = JSON.parse(JSON.stringify(state.filters));
    state.offerSessions.filtered = true;
  },
  fetchOfferSessions: (state, payload) => {
    state.offerSessions.sessions = payload.sessions;
    state.offerSessions.filtered = true;
    state.offerSessions.pagination = payload.meta.pagination;
  },
  selectSession: (state, session) => {
    state.selectedSession = session;
  },
  resetSelected: state => {
    state.selectedSession = {};
  },
  deleteFilter: (state, filter) => {
    if (filter.category === "date") {
      state.filters.date = null;
    }
    if (filter.category === "duration") {
      /*const index = this.filters.durations.indexOf(selected)
      this.filters.durations.splice(index, 1);*/
      state.filters.durations = null;
    }
    if (filter.category === "destination") {
      const index = state.filters.destinations.indexOf(filter.selected);
      state.filters.destinations.splice(index, 1);
    }
    if (filter.category === "theme") {
      const index = state.filters.themes.indexOf(filter.selected);
      state.filters.themes.splice(index, 1);
    }
  },
  deleteOfferFilter: (state, filter) => {
    if (filter.category === "date") {
      state.offerSessions.filters.date = null;
    }
    if (filter.category === "duration") {
      /*const index = this.filters.durations.indexOf(selected)
      this.filters.durations.splice(index, 1);*/
      state.offerSessions.filters.durations = null;
    }
    if (filter.category === "destination") {
      const index = state.offerSessions.filters.destinations.indexOf(
        filter.selected
      );
      state.offerSessions.filters.destinations.splice(index, 1);
    }
    if (filter.category === "theme") {
      const index = state.offerSessions.filters.themes.indexOf(filter.selected);
      state.offerSessions.filters.themes.splice(index, 1);
    }
  },
  filteredOfferSessions: (state, filter) => {
    state.offerSessions.filtered = filter;
  },
  filteredSessions: (state, filter) => {
    state.filtered = filter;
  },
  resetFilters: state => {
    state.filtered = false;
    state.filters = {
      category: null,
      offer: null,
      destinations: [],
      themes: [],
      date: null,
      durations: null
    };
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
